import React from "react"
import styles from "./toggleSwitch.module.css"

const ToggleSwitch = ({ checked = false, onChange = () => {}, disabled = false, label, description, className = "", ...props }) => (
    <button
        type="button"
        role="switch"
        aria-checked={Boolean(checked)}
        className={`${styles.control} ${checked ? styles.active : ""} ${className}`.trim()}
        disabled={disabled}
        onClick={() => !disabled && onChange(!checked)}
        {...props}
    >
        <span className={styles.track} aria-hidden="true"><span /></span>
        {(label || description) && <span className={styles.text}>
            {label && <strong>{label}</strong>}
            {description && <small>{description}</small>}
        </span>}
    </button>
)

export default ToggleSwitch
